$(document).ready(function(){
  $('.s-cartupdate__close').click(function(evt){
    evt.preventDefault();
    var cartupdate = $(this).closest('.s-cartupdate');
    cartupdate.removeClass('s-cartupdate--show');
  });
});
